import { render } from "./privacyAgreement.vue?vue&type=template&id=424f8278&scoped=true"
import script from "./privacyAgreement.vue?vue&type=script&lang=js"
export * from "./privacyAgreement.vue?vue&type=script&lang=js"

import "./privacyAgreement.vue?vue&type=style&index=0&id=424f8278&lang=less&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-424f8278"]])

export default __exports__